<template>
  <section class="upload-photo">
    <Upload
      v-if="!readOnly"
      ref="upload"
      :show-upload-list="false"
      :action="`${baseURL}base/file/publicUpload`"
      :data="uploadPram"
      :before-upload="beforeUpload"
      :on-success="onSuccess"
      :on-error="onError"
      :format="['jpg', 'jpeg', 'png']"
      :max-size="5120000"
      :headers='{"token": token}'
    >
      <Button icon="ios-cloud-upload-outline" :loading="uploading"
        >上传图片</Button
      >
    </Upload>
    <div v-if="photoUrl || defaultPhoto" :style="{ marginTop: '5px', cursor: 'pointer' }" @click="openModal">
      <Avatar shape="square" size="large" :src="photoUrl || defaultPhoto" />
    </div>
    <div v-if="!readOnly" class="tip">
      请上传jpg/png格式的图片，大小不超过5M
    </div>
    <Modal
      footer-hide
      title="查看图片"
      v-model="visiable"
      class="vertical-center-modal"
    >
      <div style="text-align: center;max-width: 300;">
        <img :src="photoUrl || defaultPhoto"/>
      </div>
    </Modal>
  </section>
</template>

<script>
import axios from 'axios';
export default {
  name: "upload-photo",
  props: {
    photoName: {
      type: String,
      default: ''
    },
    readOnly: {
      type: String,
      default: false
    },
    defaultPhoto: {
      type: String,
    },
    handleUpload: {
      type: Function
    }
  },
  data() {
    return {
      visiable: false,
      uploading: false,
      photoUrl: '',
      uploadPram: {
        scene: "SHOP"
      },
      token: sessionStorage.token,
      baseURL: ""
    };
  },
  created() {
    this.baseURL = axios.defaults.baseURL;
  },
  methods: {
    beforeUpload(v) {
      const { size, type } = v;
      if (size > 1024 * 5 * 1000) {
        this.$Message.error("图片不可大于5M");
        return false;
      }
      if (type != "image/png" && type != "image/jpg" && type != "image/jpeg") {
        this.$Message.error("仅支持jpg/png");
        return false;
      }
      this.uploading = true;
    },
    onSuccess(res) {
      const { data, code, message } = res;
      this.uploading = false;

      if (code == '200') {
        this.photoUrl = data.url;
        this.handleUpload(data.url, this.photoName);
      } else {
        this.$Message.error(message);
      }
    },
    onError() {
      this.photoUrl = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },
    openModal() {
      this.visiable = true;
    }
  }
};
</script>

<style scoped>
  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/components/uploadPhoto.vue